// extracted by mini-css-extract-plugin
module.exports = {"click-and-collect__location-finder":"click-and-collect_click-and-collect__location-finder__fFzTo"};